import React, { useReducer } from 'react'
import { t } from 'i18next';
import { getSettingService, setSettingService } from '../../services/Settings';
import PreferencesContext from './PreferencesContext';
import PreferencesReducer from './PreferencesReducer';
import { logout } from '../../services/login';

const PreferencesState = ({ children }) => {
    const initialState = {
        itemsToConfig: [],
        isFetching: true,
        error: {
            ok: false,
            text: ''
        },
    }

    const [state, dispatch] = useReducer(PreferencesReducer, initialState);

    const getSettings = async (query) => {
        try {
            const items = await getSettingService(query);

            if (items.ok) {
                dispatch({
                    type: 'GET_ITEMS_TO_CONFIG',
                    payload: {
                        itemsToConfig: items.data.response,
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'GET_ITEMS_TO_CONFIG',
                    payload: {
                        itemsToConfig: state.itemsToConfig,
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })

            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'GET_ITEMS_TO_CONFIG',
                payload: {
                    resources: state.itemsToConfig,
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }
    const setSetting = async (setting) => {
        try {
            const response = await setSettingService(setting);

            if (response.ok) {
                const { keyword, setting_value } = setting;
                changeOppositeValue(keyword, setting_value);
                dispatch({
                    type: 'CHANGE_SETTING',
                    payload: {
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (response.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'CHANGE_SETTING',
                    payload: {
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CHANGE_SETTING',
                payload: {
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
            return {
                ok: false
            }
        }
    }
    const setSection = (section) => {
        dispatch({
            type: 'SET_SHOW_SECTION',
            payload: section
        });
    }
    const changeOppositeValue = (key, value) => {
        state.itemsToConfig.forEach(el => {
            if (el.keyword === key) {
                el.setting_value = value;
            }
        });

        dispatch({
            type: 'CHANGE_SETTING_LOCAL',
            payload: state.itemsToConfig
        });
    }
    const cleanPreferencesState = (section) => {
        dispatch({
            type: 'CLEAN_STATE',
        });
    }

    return (
        <PreferencesContext.Provider
            value={{
                preferencesState: state,
                getSettings,
                setSetting,
                setSection,
                cleanPreferencesState,
                changeOppositeValue
            }}
        >
            {children}
        </PreferencesContext.Provider>
    )
}

export default PreferencesState